import { Controller } from "@hotwired/stimulus"

// Navigates to a URL when the row is clicked. Skips clicks originated from
// buttons, links, inputs or forms inside the row (so action buttons keep
// their default behavior). Full-page navigation by default ; pass
// `data-row-link-frame-value="drawer"` to navigate within a turbo-frame.
export default class extends Controller {
  static values = { url: String, frame: String }

  open(event) {
    if (event.target.closest("button, a, input, label, form")) return
    if (this.hasFrameValue && this.frameValue.length > 0) {
      Turbo.visit(this.urlValue, { frame: this.frameValue })
    } else {
      Turbo.visit(this.urlValue)
    }
  }
}
